import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { S_Modal } from '../../design/modals/modal/S_Modal';

interface ISaveBeforeSkipConfirmationModalProps {
  showSaveBeforeSkipModal: boolean;
  onSaveBeforeSkipConfirm: () => Promise<void>;
  onSaveBeforeSkipDecline: () => Promise<void>;
  onSaveBeforeSkipCancel: () => void;
}

export const SaveBeforeSkipConfirmationModal = observer((props: ISaveBeforeSkipConfirmationModalProps): ReactElement => {
  const { t } = useTranslator();
  return (
    <S_Modal
      isOpen={props.showSaveBeforeSkipModal}
      toggle={props.onSaveBeforeSkipCancel}
      headerText={t('save_changes')}
      buttons={
        <>
          <Button
            color='neutral'
            variant='outlined'
            onClick={props.onSaveBeforeSkipCancel}
          >
            {t('cancel')}
          </Button>
          <Button
            variant='outlined'
            onClick={() => {
              void props.onSaveBeforeSkipDecline();
            }}
          >
            {t('do_not_save')}
          </Button>
          <Button
            onClick={() => {
              void props.onSaveBeforeSkipConfirm();
            }}
          >
            {t('save')}
          </Button>
        </>
      }
    >
      {t('skip_confirm_message')}
    </S_Modal>
  );
});
